import getStore from 'services/getStore';
import pubSub from 'services/pubSub';
// import getCurrentLocation from 'services/getCurrentLocation';

const store = getStore();

const interactionsSeen = [];
let debounceScrolling;

let oldTopic;
let newTopic;
let topicUpdated;

let oldPosition = 0;
let newPosition = 0;

const clearHistory = () => {
  requestAnimationFrame(
    () =>
      (window.location.hash = Math.random()
        .toString(16)
        .substr(2, 8))
  );
  window.locationHistory = null;
};

// when the pattern settles. all this will just publish an object with
// all this

const windowScrollInfo = (e, currentTopic) => {
  if (currentTopic) {
    newTopic = currentTopic;
  }

  clearTimeout(debounceScrolling);

  debounceScrolling = setTimeout(() => {
    let scrollDirection;

    if (oldTopic !== newTopic) {
      topicUpdated = true;
      oldTopic = newTopic;
    } else {
      topicUpdated = false;
    }

    if (!topicUpdated) {
      newPosition = window.scrollY;

      if (oldPosition !== newPosition) {
        scrollDirection = oldPosition < newPosition ? 'down' : 'up';

        // either direction. might change. us direction for other things. . .
        if (
          window.locationHistory &&
          ['up', 'down'].includes(scrollDirection)
        ) {
          clearHistory();
        }

        oldPosition = newPosition;
      }
    }

    // return;

    // we're not gonna use this now. but we could come back to it
    // and update interactionsSeen in the store from here

    const sections = Array.from(document.querySelectorAll('section'));

    const sectionInView: any = sections
      .reduce((acc, curr, index) => {
        const { top, height } = curr.getBoundingClientRect();

        return [
          ...acc,
          {
            section: curr,
            id: curr.id.replace(/i/, ''),
            inView: height
              ? top >= 0 - height / 2 && top <= window.innerHeight / 2
              : false,
            index,
          },
        ];
      }, [])
      .find(s => s.inView);

    if (window['sectionInView'] !== sectionInView) {
      window['sectionInView'] = sectionInView;

      pubSub.publish('SECTION_IN_VIEW', {
        sectionInView,
      });
    }

    // console.log(sectionInView, window['sectionInView']);
    if (!window['sectionInView']) {
      return;
    }

    if (!interactionsSeen.includes(window['sectionInView'].id)) {
      interactionsSeen.push(window['sectionInView'].id);
      // console.log(window['sectionInView'], interactionsSeen);

      store.dispatch({
        type: 'UPDATE_INTERACTIONS_SEEN',
        data: {
          id: window['sectionInView'].id,
        },
      });
    }
  }, 100);
};

window.addEventListener('scroll', e => windowScrollInfo(e, null));

export default windowScrollInfo;
